/** Markdown с таблицами в оформлении кабинета: разборы «Анализа» и инструкции к экранам. */
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

const card = "rounded-[var(--radius-card)] border border-border bg-bg-subtle";

export function Prose({ children }: { children: string }) {
  return (
    <Markdown
      remarkPlugins={[remarkGfm]}
      components={{
        h1: (p) => <h1 className="mt-3 mb-4 text-[24px] font-semibold tracking-[-0.02em]" {...p} />,
        h2: (p) => <h2 className="mt-8 mb-3 border-t border-border pt-5 text-[18px] font-semibold" {...p} />,
        h3: (p) => <h3 className="mt-5 mb-2 text-[15px] font-semibold" {...p} />,
        h4: (p) => <h4 className="mt-5 mb-2 text-[14px] font-semibold" {...p} />,
        p: (p) => <p className="my-3" {...p} />,
        ul: (p) => <ul className="my-3 list-disc pl-5 [&>li]:my-1" {...p} />,
        ol: (p) => <ol className="my-3 list-decimal pl-5 [&>li]:my-1.5" {...p} />,
        blockquote: (p) => <blockquote className="my-3 border-l-2 border-border pl-3 text-fg-muted" {...p} />,
        code: (p) => <code className="rounded bg-bg-subtle px-1 text-[12.5px]" {...p} />,
        img: (p) => <img className="h-[200px] w-auto max-w-none rounded" loading="lazy" {...p} />,
        table: (p) => (
          <div className={`${card} my-4 overflow-x-auto`}>
            <table className="w-full border-collapse text-[13px] tabular-nums" {...p} />
          </div>
        ),
        th: (p) => <th className="whitespace-nowrap border-b border-border px-2.5 py-1.5 text-left font-medium text-fg-muted" {...p} />,
        td: (p) => <td className="border-b border-border px-2.5 py-1.5 last:border-b-0" {...p} />,
      }}
    >
      {children}
    </Markdown>
  );
}
